module.exports = __webpack_public_path__ + "static/media/kz.0855baa1.svg";